export default __webpack_public_path__ + "static/media/icon-profile.5ed0a5fa.png";